module.exports = __webpack_public_path__ + "officialStatic/img/schoolD.8262895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/schoolD.png
// module id = C/mC
// module chunks = 0